import type { WhatsAppConnectionState } from "@multi-chat/shared";

/** Template list/sync UI is available only while WhatsApp is fully connected. */
export function canLoadWhatsAppTemplates(
  connectionState: WhatsAppConnectionState,
): boolean {
  return connectionState === "CONNECTED";
}

export function shouldShowWhatsAppTemplatesConnectionRequired(
  connectionState: WhatsAppConnectionState,
): boolean {
  return connectionState === "DISCONNECTED" || connectionState === "NOT_CONNECTED";
}

/** Client state applied when template APIs must not be loaded or shown. */
export const whatsAppTemplatesDisabledClientState = {
  loadState: "ready",
  items: [],
  lastSyncedAt: null,
  loadError: null,
  syncError: null,
  syncing: false,
} as const;
